export function setRobotsNoindex() {
    setRobotsValue("noindex, nofollow");
}

export function setRobotsValue(contentValue) {
    let robots = document.querySelector("[name='robots']");
    if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.querySelector("head").appendChild(robots);
    }
    robots.setAttribute("content", contentValue);
}